import React, { useEffect, useState } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import Button from '../../components/Buttons/CommonButton';
import LoginLayout from '../../components/LoginLayout/LoginLayout';
import { useTranslation } from 'react-i18next';

import * as endpoints from '../../constants/endpoints';
import { useDispatch } from 'react-redux';
import { notificationsActions } from '../../store';
import { Helmet } from 'react-helmet-async';
import useDispatchNotification from '../../hooks/notifications/useDispatchNotification';
import {
    getScreenApprovalOutcome,
    SCREEN_APPROVAL_OUTCOMES,
} from '../../utils/screenApprovalOutcome';

function ScreenApproval({}) {
    const dispatch = useDispatch();
    const useQuery = () => new URLSearchParams(useLocation().search);
    let query = useQuery();
    const publisher = encodeURIComponent(query.get('publisher'));
    const campaignInfo = query.get('campaignInfo');
    const emailResponded = query.get('email');
    let { operation, campaignid, token } = useParams();
    const { errorNotification, successNotification } =
        useDispatchNotification();
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(false);
    const [title] = useState(
        operation === 'approve'
            ? t('sections.screenApproval.message-approve-title')
            : t('sections.screenApproval.message-reject-title')
    );

    let strOperation =
        operation === 'approve'
            ? t('sections.screenApproval.approve')
            : t('sections.screenApproval.reject');
    const handleSubmit = async (event) => {
        event.preventDefault();
        let url = `${endpoints.backendV2}/screens/${operation}/${campaignid}/${token}?publisher=${publisher}&email=${emailResponded}`;
        setIsLoading(true);
        fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then(async (response) => {
                const body = await response.json().catch(() => null);
                const outcome = getScreenApprovalOutcome(response.status, body);

                if (outcome === SCREEN_APPROVAL_OUTCOMES.SUCCESS) {
                    successNotification(
                        title,
                        operation === 'approve'
                            ? t('sections.screenApproval.ok-approve')
                            : t('sections.screenApproval.ok-reject')
                    );
                } else if (outcome === SCREEN_APPROVAL_OUTCOMES.EXPIRED) {
                    errorNotification(
                        title,
                        t('sections.screenApproval.err-token-expired')
                    );
                } else {
                    errorNotification(
                        title,
                        t('sections.screenApproval.err-message')
                    );
                }
            })
            .catch((err) => {
                console.log('err: ', err);
                errorNotification(
                    title,
                    t('sections.screenApproval.err-message')
                );
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    return (
        <>
            <Helmet>
                <title>{`${title} - ${process.env.REACT_APP_WL_COMPANY_NAME}`}</title>
            </Helmet>
            <LoginLayout>
                <div className="text-gray-500 mb-12">
                    <h1 data-test="h1Title" className="font-bold text-3xl mb-2">
                        {publisher
                            ? decodeURIComponent(publisher)
                            : 'Publisher'}
                    </h1>
                    <p data-test="pDescription">
                        {t('sections.screenApproval.really', {
                            operation: strOperation,
                            campaign: campaignid,
                        })}
                        <b className="font-bold lowercase">
                            {' '}
                            #{campaignInfo ? campaignInfo : campaignid}
                        </b>
                        ?
                    </p>
                </div>
                <form autoComplete="off" onSubmit={handleSubmit}>
                    <div className="my-4 flex text-center ">
                        <Button
                            dataTest="btnAccept"
                            label={
                                operation === 'approve'
                                    ? t('sections.screenApproval.approve')
                                    : t('sections.screenApproval.reject')
                            }
                            styleType={
                                operation === 'approve' ? 'primary' : 'danger'
                            }
                            className="w-full"
                        />
                        <a
                            data-test="aCancel"
                            className="capitalize bg-white hover:bg-gray-200 text-black rounded border border-gray-200 transition-colors duration-300 ease-in-out font-light text-sm p-1 py-2 px-2 lg:px-4 focus:outline-none ml-2 w-full"
                            styleType={'secondary'}
                            href="https://www.taggify.net/"
                        >
                            {t('common.buttons.cancel')}
                        </a>
                    </div>
                </form>
            </LoginLayout>
        </>
    );
}

export default ScreenApproval;
